import React from 'react'
import { withStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import ArrowIcon from '@material-ui/icons/KeyboardArrowDown'

const style = theme => ({
	root: {

	},
	linkRow: {
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
	},
	rotate: {
		transform: 'rotate(180deg)'
	}
})

function OpenBarText({
	classes,
	text,
	onClick,
	rotate=false,
}) {
	return (
		<div
			onClick={onClick}
			className={classes.linkRow}
		>
			<Typography
				variant='caption'
			>
				{text}
			</Typography>
			<ArrowIcon
				className={clsx({
					[classes.rotate]: rotate
				})}
			/>
		</div>
	)
}

OpenBarText.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(OpenBarText);